import blockBgColorField from '../fields/blockBgColorField';
import blockImageField from '../fields/blockImageField';

export default {
  value: 'asymmetric_header',
  label: 'Asymmetric Header',
  fields: {
    left: [
      blockBgColorField,
      {
        label: 'Title',
        name: 'title'
      },
      {
        label: 'Content',
        name: 'content',
        type: 'richText'
      }
    ],
    right: [blockImageField]
  }
};
